/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatusRequest
 */
export interface StatusRequest {
    /**
     * 
     * @type {StatusRequestSegmentStatusEnum}
     * @memberof StatusRequest
     */
    segmentStatus: StatusRequestSegmentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StatusRequest
     */
    comment?: string | null;
}


/**
 * @export
 */
export const StatusRequestSegmentStatusEnum = {
    Open: 'Open',
    InLocalReview: 'InLocalReview',
    InGlobalReview: 'InGlobalReview',
    Approved: 'Approved'
} as const;
export type StatusRequestSegmentStatusEnum = typeof StatusRequestSegmentStatusEnum[keyof typeof StatusRequestSegmentStatusEnum];


/**
 * Check if a given object implements the StatusRequest interface.
 */
export function instanceOfStatusRequest(value: object): value is StatusRequest {
    if (!('segmentStatus' in value) || value['segmentStatus'] === undefined) return false;
    return true;
}

export function StatusRequestFromJSON(json: any): StatusRequest {
    return StatusRequestFromJSONTyped(json, false);
}

export function StatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'segmentStatus': json['segmentStatus'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function StatusRequestToJSON(json: any): StatusRequest {
    return StatusRequestToJSONTyped(json, false);
}

export function StatusRequestToJSONTyped(value?: StatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'segmentStatus': value['segmentStatus'],
        'comment': value['comment'],
    };
}

